import { Component, OnInit } from '@angular/core';
import { Product } from '../../../dto/product';
import {ParamMap, Router} from '@angular/router';
import { ActivatedRoute } from '@angular/router';
import { Location } from '@angular/common';
import { ProductService } from '../../services/product.service';
import { environment } from '../../../../environments/environment';
import { RoleService } from '../../../services/role.service';


import {RiskService} from '../../services/risk.service';
import {RiskAssementInquiry} from '../../../dto/risk-assement-inquiry';
import {Customer} from '../../../dto/customer';
import {toDateString} from '../../../providers/app-date-adapter';
import {CustomerRisk} from '../../../dto/customer-risk';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {BadgeService} from '../../services/badge.service';
import {Order} from '../../../dto/order';
import {ContentRowField} from '../../../shared/content-row/content-row.component';
import {byNumeric} from 'iso-country-codes';
import {CityInfo} from '../../../dto/GeoIp/city-info';
import {GeoIpService} from '../../../services/geo-ip.service';

@Component({
  selector: 'app-risk-check-detail',
  templateUrl: './risk-check-detail.component.html',
  styleUrls: ['./risk-check-detail.component.css']
})
export class RiskCheckDetailComponent implements OnInit {
  private ipCityInfo: CityInfo|null;


  constructor(
    private router: Router,
    private location: Location,
    private route: ActivatedRoute,
    private roleService: RoleService,
    private riskService: RiskService,
    private formBuilder: FormBuilder,
    private badgeService: BadgeService,
    private geoIpService: GeoIpService,

  ) { }

  fieldsCustomer = [
    { header: 'Link', icon: (row: CustomerRisk) => 'visibility', link: (row: CustomerRisk) => '../../../customers-overview/' + (row.id || ''), cell: (row: CustomerRisk) => `Customer` } as ContentRowField<CustomerRisk>,
    { header: 'Name / DOB', cell: (row: CustomerRisk) => `${row.title} ${row.firstName} ${row.lastName}`, cell2: (row: CustomerRisk) => `${toDateString(row.dob) || ''}` } as ContentRowField<CustomerRisk>,
    { header: 'Address', cellFlag: (row: CustomerRisk) => byNumeric[row.countryIsoCode.toString().padStart(3, '0')].alpha2, cell: (row: CustomerRisk) => `${row.address || ''}, ${row.zipCode || ''} ${row.city || ''}, ${row.countryName || ''}` } as ContentRowField<CustomerRisk>,
    { header: 'Email', cell: (row: CustomerRisk) => `${row.email || ''}` } as ContentRowField<CustomerRisk>,
    { header: 'Mobile', cell: (row: CustomerRisk) => `+${row.phone || ''}` } as ContentRowField<CustomerRisk>,


    {header: 'IP Address', cellFlag: (row: CustomerRisk) => this.ipCityInfo?.countryAlphaIsoCode || null
      , cell: (row: CustomerRisk) => {
        const ret = row.ipAddress || '';
        if ( ret && this.ipCityInfo ) {
          //ret += " (" + this.ipCityInfo.postCode + " " + this.ipCityInfo.city + " " + this.ipCityInfo.countryName + ")"
        }
        return ret;

      }},

  ]  as ContentRowField<CustomerRisk>[];

  fieldsLoad = [
    { header: 'Sepa count / sum', cell: ( row: CustomerRisk ) => `${ row.riskSumLoadSepaCount }`, cell2: ( row: CustomerRisk ) => `${ row.riskSumLoadSepa.formatThousands() }` } as ContentRowField<CustomerRisk>,
    { header: 'Sofort count / sum', cell: ( row: CustomerRisk ) => `${ row.riskSumLoadSofortCount }`, cell2: ( row: CustomerRisk ) => `${ row.riskSumLoadSofort.formatThousands() }` } as ContentRowField<CustomerRisk>,
    { header: 'BTL count / sum', cell: ( row: CustomerRisk ) => `${ row.riskSumBankTransferLoadCount }`, cell2: ( row: CustomerRisk ) => `${ row.riskSumBankTransferLoad.formatThousands() }` } as ContentRowField<CustomerRisk>,
    { header: 'C2C In count / sum', cell: ( row: CustomerRisk ) => `${ row.riskSumCardToCardInboundCount }`, cell2: ( row: CustomerRisk ) => `${ row.riskSumCardToCardInbound.formatThousands() }` } as ContentRowField<CustomerRisk>,
    { header: 'Total load sum', cell: (row: CustomerRisk) => '', cell2: ( row: CustomerRisk ) => `${ row.riskSumLoadTotal.formatThousands() }` } as ContentRowField<CustomerRisk>,
  ] as ContentRowField<CustomerRisk>[];

  inquiryForm: FormGroup = null;

  inquiry: RiskAssementInquiry = null;
  inquiryId: number = null;

  ngOnInit() {

    this.route.paramMap.subscribe((params: ParamMap)=> {
      this.inquiryId=parseInt(params.get('id'));
      this.loadInquiry();
    });

  }

  loadInquiry(){

    if( this.currentUserIsPartner() ) {
return;
}

    this.riskService.get(this.inquiryId).subscribe(result => {
      this.inquiry = result;
      const customer = this.inquiry.customer;
      if ( customer.ipAddress ) {
this.geoIpService.getCityByIp(customer.ipAddress).subscribe(city => this.ipCityInfo = city, err => {});
}


      this.inquiryForm = this.formBuilder.group({
        id: [this.inquiryId],
        finishedComment: [this.inquiry.finishedComment, Validators.required],
        finishedRiskLevel: [this.inquiry.finishedRiskLevel, Validators.required],
      });

    });
  }

  onSubmit(){

    const req = this.inquiry;

    req.finishedComment = this.inquiryForm.value.finishedComment;
    req.finishedRiskLevel = this.inquiryForm.value.finishedRiskLevel;
    this.riskService.update(req)
      .subscribe(res => {
          this.returnBack();
          this.badgeService.refreshBadge('compliance');
      }
      );

  }

  delete(){
    this.riskService.delete(this.inquiryId)
      .subscribe(res => {
        this.returnBack();
        this.badgeService.refreshBadge('compliance');
      });
  }

  returnBack() {
    this.location.back();
  }

  currentUserIsAdmin(): boolean {
    return this.roleService.hasRoles( 'admin' );
  }
  currentUserIsSuperAdmin(): boolean {
    return this.roleService.hasRoles( 'super_admin' );
  }

  currentUserIsCompliance(): boolean {
    return this.roleService.hasRoles( 'compliance' );
  }


  currentUserIsFinanceManager(): boolean {
    return this.roleService.hasRoles( 'finance_manager' );
  }

  currentUserIsPartner(): boolean {
    return this.roleService.hasRoles(['partner', 'partner_support']);
  }

  getCurrentRiskLevel(){
    if( this.inquiry && this.inquiry.customer ){
      let lvl = 0;
      if( this.inquiry.customer.riskLevelOverride != null ){
        lvl = this.inquiry.customer.riskLevelOverride;
      }else{
        lvl = this.inquiry.customer.riskLevel;
      }

      if( lvl == 0 ) {
        return 'low';
      } else if( lvl == 1 ){
        return 'medium';
      } else if( lvl == 2 ){
        return 'high';
      }

    }

    return '-';

  }

  getRiskClass() {

    if( this.inquiry && this.inquiry.customer ) {

      const row = this.inquiry.customer;

      let lvl = 0;

      if (row.riskLevelOverride != null) {
        lvl = row.riskLevelOverride;
      } else {
        lvl = row.riskLevel;
      }

      if (lvl != null) {

        if (lvl == 0) {
          return 'risk-low-text';
        }

        if (lvl == 1) {
          return 'risk-medium-text';
        }

        if (lvl == 2) {
          return 'risk-high-text';
        }

      }

    }

    return '';


  }



}
